import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "Servicios", id: "#servicios" },
  { label: "Nosotros", id: "#nosotros" },
  { label: "Casos de éxito", id: "#casos" },
  { label: "Valoración", id: "#valoracion" },
  { label: "Contacto", id: "#contacto" },
  { label: "Calculadora fiscal", id: "/herramientas/calculadora-fiscal", route: true },
  { label: "Diagnóstico de circulante", id: "/herramientas/diagnostico-circulante", route: true },
  { label: "Capacidad de compra", id: "/herramientas/cuanto-puedo-pagar", route: true },
  { label: "Test de venta", id: "/herramientas/test-venta", route: true },
  { label: "Simulador de márgenes", id: "/herramientas/simulador-margenes", route: true },
];

const LEGAL = [
  { label: "Aviso legal", to: "/aviso-legal", testid: "footer-legal-aviso" },
  { label: "Política de privacidad", to: "/privacidad", testid: "footer-legal-privacidad" },
  { label: "Política de cookies", to: "/cookies", testid: "footer-legal-cookies" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-ink pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <img src="/logo-light.png" alt="AJG M&A Consulting" className="h-20 w-auto" data-testid="footer-logo" />
            <p className="mt-6 max-w-sm font-serif text-xl italic text-slate-300">
              Consultoría Estratégica, Financiera y M&amp;A
            </p>
            <a
              href="https://www.linkedin.com/company/ajg-m-a-consulting/home/"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-link-linkedin"
              aria-label="LinkedIn de AJG M&A Consulting"
              className="mt-8 inline-flex h-11 w-11 items-center justify-center border border-gold/40 text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
            >
              <Linkedin className="h-5 w-5" />
            </a>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Navegación</h4>
            <ul className="mt-6 space-y-4">
              {NAV.map((l) => (
                <li key={l.id}>
                  {l.route ? (
                    <Link
                      to={l.id}
                      data-testid={`footer-link-${l.id.replace(/\//g, "-").slice(1)}`}
                      className="text-sm text-slate-300 transition-colors hover:text-gold"
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <a
                      href={l.id}
                      data-testid={`footer-link-${l.id.slice(1)}`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToId(l.id);
                      }}
                      className="text-sm text-slate-300 transition-colors hover:text-gold"
                    >
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Contacto</h4>
            <ul className="mt-6 space-y-4 text-sm text-slate-300">
              <li>
                <a href="tel:+34654943319" data-testid="footer-phone-link" className="transition-colors hover:text-gold">
                  654 943 319
                </a>
              </li>
              <li>
                <a
                  href="mailto:adminajgconsulting@gmail.com"
                  data-testid="footer-email-link"
                  className="break-all transition-colors hover:text-gold"
                >
                  adminajgconsulting@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold">Legal</h4>
            <ul className="mt-6 space-y-4">
              {LEGAL.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.testid}
                    className="text-sm text-slate-300 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-gold/10 pt-8 md:flex-row md:items-center">
          <p className="text-xs tracking-wide text-slate-500" data-testid="footer-copyright">
            © 2026 AJG M&amp;A Consulting, S.L. Todos los derechos reservados.
          </p>
          <p className="text-xs tracking-wide text-slate-500">Privado y confidencial</p>
        </div>
      </div>

      <span
        aria-hidden
        className="pointer-events-none absolute -bottom-24 right-0 select-none font-serif italic leading-none text-white/[0.03] text-[14rem] md:text-[20rem]"
      >
        AJG
      </span>
    </footer>
  );
}
